import { Injectable } from '@angular/core';
import moment from 'moment';
import * as Highcharts from 'highcharts';
import flatpickr from 'flatpickr';
import flatpickrL10n from 'flatpickr/dist/l10n';
import * as _ from 'lodash';

const DateFormats = {
    default: {
        longDateFormat: {
            LT: 'HH:mm', // 21:15
            LTS: 'HH:mm:ss', // 21:15:50
            L: 'DD.MM.YY', // 24.12.17
            LL: 'DD.MM.YYYY', // 24.12.2017
            LLL: 'D MMMM, YYYY', // 24 December, 2017
            LLLL: 'dddd, D MMMM, YYYY', // Friday, 24 December, 2017
        },
        week: {
            dow: 1, // Monday is the first day of the week,
            doy: 4,
        },
    },
};
export const agGridLocale = {
    // Set Filter
    selectAll: $localize`:|:(Select All)`,
    searchOoo: $localize`:|:Search...`,
    blanks: $localize`:|:(Blanks)`,

    // Number Filter & Text Filter
    filterOoo: $localize`:|:Filter...`,
    equals: $localize`:|:Equals`,
    notEqual: $localize`:|:Not equal`,
    blank: $localize`:|:Blank`,
    notBlank: $localize`:|:Not blank`,

    // Number Filter
    lessThan: $localize`:|:Less than`,
    greaterThan: $localize`:|:Greater than`,
    inRange: $localize`:|:In range`,
    lessThanOrEqual: $localize`:|:Less than or equal`,
    greaterThanOrEqual: $localize`:|:Greater than or equal`,

    // Text Filter
    contains: $localize`:|:Contains`,
    notContains: $localize`:|:Not contains`,
    startsWith: $localize`:|:Starts with`,
    endsWith: $localize`:|:Ends with`,

    // Menu
    resetColumns: $localize`:|:Reset Columns`,
    copy: $localize`:|:Copy`,
    excelExport: $localize`:|:Excel Export`,
};

@Injectable()
export class LocaleService {
    setLocale(language = 'en') {
        // first load moment's language for use
        moment.locale(language);

        // then change to use the ChargEye global date format settings for this locale
        moment.updateLocale(language, this.getMomentFormatSettings(language));

        // then load flatpickr's language maps
        const languageMap = {
            en: flatpickrL10n.en,
            fr: flatpickrL10n.fr,
            fi: flatpickrL10n.fi,
            // Add more language mappings as needed
        };

        // then load flatpickr's language for use
        flatpickr.localize(languageMap[language]);

        // set global highcharts translations for use in various charts and graphs
        Highcharts.setOptions({
            lang: {
                months: moment.months(),
                weekdays: moment.weekdays(),
                shortMonths: moment.monthsShort(),
                shortWeekdays: moment.weekdaysShort(),
            },
        });
    }

    private getMomentFormatSettings(language: string) {
        // get the default date format
        const dateFormat = _.cloneDeep(DateFormats.default);

        // apply locale specific settings
        _.merge(dateFormat, DateFormats[language]);
        return dateFormat;
    }
}
